import { render, staticRenderFns } from "./HistoryModal.vue?vue&type=template&id=2af4afb2&scoped=true"
import script from "./HistoryModal.vue?vue&type=script&lang=js"
export * from "./HistoryModal.vue?vue&type=script&lang=js"
import style0 from "./HistoryModal.vue?vue&type=style&index=0&id=2af4afb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af4afb2",
  null
  
)

export default component.exports